import { render, staticRenderFns } from "./myComment.vue?vue&type=template&id=d4a06308&scoped=true"
import script from "./myComment.vue?vue&type=script&lang=js"
export * from "./myComment.vue?vue&type=script&lang=js"
import style0 from "./myComment.vue?vue&type=style&index=0&id=d4a06308&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a06308",
  null
  
)

export default component.exports